import { ExperimentFeature } from '@fullstory/proto/fs/services/orgs';
import { RequestActionType } from '@fullstory/redux-util';
import { ExperimentRequestTypes } from './types';
import { ExperimentRequestActions } from './actions';

type ExperimentConfigState = {
  [key in ExperimentFeature]: boolean;
} & {
  umbrellaOptedOut: boolean;
};

const initialState: ExperimentConfigState = {
  [ExperimentFeature.FEATURE_INVALID]: true,
  // while the org default for individual features is opt-in, if we don't have a response, keep it as opt-out
  [ExperimentFeature.FEATURE_SESSION_SUMMARY]: true,
  [ExperimentFeature.FEATURE_PLAYLIST_SUMMARIES]: true,
  [ExperimentFeature.FEATURE_SELECTOR_TRIM]: true,
  [ExperimentFeature.FEATURE_SUGGESTED_ELEMENTS]: true,
  [ExperimentFeature.FEATURE_SUGGESTED_LABELS]: true,
  [ExperimentFeature.FEATURE_SUGGESTED_PAGES]: true,
  // however, if there is no response for "all", still keep that component as the default (opted-in)
  [ExperimentFeature.FEATURE_ALL]: false,
  umbrellaOptedOut: false,
};

export const experimentConfigReducer = (
  state: ExperimentConfigState = initialState,
  action: RequestActionType<typeof ExperimentRequestActions>,
): ExperimentConfigState => {
  switch (action.type) {
    case ExperimentRequestTypes.GetAllExperimentsOptedOutSuccess: {
      const optOuts = action.data.optOuts;
      if (!optOuts) {
        return state;
      }
      let umbrellaOptedOut = state.umbrellaOptedOut;
      const isUmbrella = !!action.request.body?.entityId?.umbrellaId;
      if (isUmbrella) {
        umbrellaOptedOut = optOuts.some(
          o => o.feature === ExperimentFeature.FEATURE_ALL && o.optedOut,
        );
        return {
          ...state,
          umbrellaOptedOut,
        };
      }
      return {
        ...state,
        ...Object.fromEntries(action.data.optOuts.map(o => [o.feature, o.optedOut])),
        umbrellaOptedOut,
      };
    }
    case ExperimentRequestTypes.SetExperimentOptedOutSuccess: {
      const body = action.request.body;
      if (body == null) {
        return state;
      }
      return {
        ...state,
        [body.feature]: body.optedOut,
      };
    }
    default:
      return state;
  }
};
